import "./App.css";
import UniquickSolutions from "./page/UniquickSolutions";

function App() {
  return (
    <div className="App">
      <UniquickSolutions />
    </div>
  );
}

export default App;
